import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { toast } from "react-toastify";

const ProfileData = () => {

  const {state, dispatch} = useContext(UserContext)

  const [profile, setProfile] = useState(
    {
      user: {
        name: "",
        email: "",
        profilepic: ""
      },
      about: "",
      facebook: "",
      instagram: "",
      twitter: "",
      linkedln: "",
    }
  );

  const [pic, setProfilePic] = useState()

  const { id } = useParams();
  let navigate = useNavigate();
  
  let namee, value;
  const dataInputFn = (event) => {
    namee = event.target.name;
    value = event.target.value;
    setProfile({ ...profile, user: { ...profile.user, [namee]: value }});
  };

  let nameee, valuee;
  const dataInputFn2 = (event) => {
    nameee = event.target.name;
    valuee = event.target.value;
    setProfile({ ...profile, [nameee]: valuee });
  };

  const uploadProPicFn = async() => {
    try {
      const data = new FormData();
      data.append("file", pic);
      data.append("upload_preset", "blogify-web");
      data.append("cloud_name", "ninja-cloud");

      const res = await axios.post(
        "https://api.cloudinary.com/v1_1/ninja-cloud/image/upload",
        data
      );
      if (res.status === 200) {
        const imageUrl = res.data.secure_url;
        setProfile({ ...profile, user: { ...profile.user, profilepic: imageUrl } });
        localStorage.setItem('user', JSON.stringify({...state, profilepic: imageUrl}))
        dispatch({type: "UPDATEPROFILEPIC", payload: imageUrl})
      }
    } catch (error) {
    }
  };
  

  //this help to load data on edit page
  const onloadProfileDetails = async () => {
    try {
      const response = await axios.get(`https://blogappserver-8sw1.onrender.com/profile/edit/${id}`, {
        withCredentials: true
      });
      setProfile({ ...profile, ...response.data});
    } catch (error) {
    }
  };
  
  const updateProfile = async (e) => {
    e.preventDefault()
    try {
      const res = await axios.put(`https://blogappserver-8sw1.onrender.com/profile/edit/${id}`, {...profile ,...profile.user}, {
        withCredentials: true
      });
      navigate("/profile", { replace: true });
      toast("successfully updated..!!", {type: "success"})
     
      if (!res.status === 200) {
        throw new Error(res.error);
      }
    } catch (error) {
      toast("try it again..!!", {type: "error"})
    }
  };
  
  useEffect(() => {
    if(pic) {
      uploadProPicFn()
    }
    onloadProfileDetails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pic]);
 
  return (
    <>
      <form action="/profile" method="POST" encType="multipart/form-data" className="mt-5">
        <div className="form-group mb-2 mx-5">
          <label htmlFor="title">Profile Name</label>
          <input
            required
            type="text"
            name="name"
            id="name"
            value={profile.user.name}
            onChange={dataInputFn}
            className="form-control"
          />
        </div>

        <div className="form-group mb-2 mx-5">
          <label htmlFor="profilepic">Profile Pic
            <span style={{color: "red"}}>[after uploading wait..!!]</span>
          </label>
          <input
            type="file"
            name="profilepic"
            id="profilepic"
            onChange={(e) => setProfilePic(e.target.files[0])}
            className="form-control"
          />
        </div>

        <div className="form-group mb-2 mx-5">
          <label htmlFor="description">About..
            <span style={{color: "red"}}>[Exceed up 25 characters]</span>
          </label>
          <textarea
            required
            name="about"
            id="about"
            value={profile.about}
            onChange={dataInputFn2}
            maxLength={25}
            className="form-control"
          ></textarea>
        </div>

        <div className="form-group mb-2 mx-5 my-2">
          <label htmlFor="sociallinks">Social Media [Only Enter Username..]</label>

          <div className="row mb-2">
            <div className="col">
              <input
                type="text"
                id="facebook"
                name="facebook"
                value={profile.facebook}
                onChange={dataInputFn2}
                className="form-control"
                placeholder="facebook username" />
            </div>
            <div className="col">
              <input
                type="text"
                id="instagram"
                name="instagram"
                value={profile.instagram}
                onChange={dataInputFn2}
                className="form-control"
                placeholder="instagram username"
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col">
              <input
                type="text"
                id="linkedln"
                name="linkedln"
                value={profile.linkedln}
                onChange={dataInputFn2}
                className="form-control"
                placeholder="linkedIn username"
              />
            </div>
            <div className="col">
              <input
                type="text"
                id="twitter"
                name="twitter"
                value={profile.twitter}
                onChange={dataInputFn2}
                className="form-control"
                placeholder="twitter username"/>
            </div>
          </div>
        </div>

        <div className="text-center mt-5 btn-div">
          <button
            type="submit"
            onClick={updateProfile}
            className="btn btn-primary btn-sm btn-prop"
          >
            Save
          </button>

          <button
            type="button"
            onClick={() => navigate('/profile')}
            className="btn btn-primary btn-sm btn-prop"
          >
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};

export default ProfileData;
